import React from 'react'

const GroupsContact = generalCap => {
  let text = `For parties larger than ${generalCap.generalCap}, please `
  let introText = `Booking a group visit? `

  return (
    <p
      role="status"
      className="font-bold xs-paragraph"
    >
      {introText}
      <span className="font-light">
        {text}
        <a
          className="text-link-small"
          href="/plan-a-visit/group-visits"
        >
          plan your group visit here.
        </a>
      </span>
    </p>
  )
}

export default GroupsContact
